import retryEnhancer from '@rpldy/retry-hooks'
import Uploady from '@rpldy/uploady'
import { ReactElement, ReactNode } from 'react'

import { getAccessToken } from '../../../utils'
import { AttachmentsUploadManagerContextProvider } from './attachmentsUploadManagerContext'

interface AttachmentsUploaderContextProviderProps {
  children?: ReactNode
  sessionId: string
  url: string
}

export const AttachmentsUploaderContextProvider = ({
  children,
  sessionId,
  url,
}: AttachmentsUploaderContextProviderProps): ReactElement => {
  return (
    <Uploady
      destination={{
        url,
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
        params: { sessionId }, // adding this param to retrieve it in the useFileAttachmentsUploader
      }}
      enhancer={retryEnhancer}
      inputFieldName="qqfile"
      multiple
    >
      <AttachmentsUploadManagerContextProvider>{children}</AttachmentsUploadManagerContextProvider>
    </Uploady>
  )
}
